(() => {
  if (window.beauLakeCaseStudiesInit) { window.beauLakeCaseStudiesInit(); return; }
  let storiesPromise;
  const initialize = () => document.querySelectorAll('[data-case-studies-menu]').forEach(menu => {
    if (menu.dataset.caseStudiesReady) return;
    const trigger = menu.querySelector('[data-case-studies-link]');
    const media = menu.querySelector('.mega-menu-split__media');
    if (!trigger || !media) return;
    menu.dataset.caseStudiesReady = 'true';
    const original = Array.from(media.children).map(node => node.cloneNode(true));
    const columns = menu.style.getPropertyValue('--mega-menu-split-cols');
    let selected = false;
    const restore = () => {
      selected = false;
      media.replaceChildren(...original.map(node => node.cloneNode(true)));
      menu.style.setProperty('--mega-menu-split-cols', columns);
      menu.removeAttribute('data-case-studies-active');
    };
    const show = async () => {
      selected = true;
      if (!storiesPromise) storiesPromise = fetch(trigger.href).then(response => {
        if (!response.ok) throw new Error('Case studies unavailable');
        return response.text();
      }).then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const stories = Array.from(doc.querySelectorAll('.bl-stories-grid article')).slice(0, 4).map(article => ({
          title: article.querySelector('h3')?.textContent.trim(),
          href: article.querySelector('a')?.getAttribute('href'),
          src: article.querySelector('img')?.getAttribute('src'),
          srcset: article.querySelector('img')?.getAttribute('srcset')
        }));
        if (stories.length !== 4 || stories.some(story => !story.title || !story.href || !story.src)) throw new Error('Missing case studies');
        return stories;
      }).catch(error => { storiesPromise = null; throw error; });
      try {
        const stories = await storiesPromise;
        if (!selected || !menu.isConnected) return;
        const cards = stories.map(story => {
          const card = document.createElement('li'); card.className = 'mega-menu-split__card';
          const link = document.createElement('a'); link.className = 'mega-menu-split__card-link group'; link.href = story.href;
          const frame = document.createElement('span'); frame.className = 'mega-menu-split__media-frame';
          const image = document.createElement('img'); image.className = 'mega-menu-split__image zoom-image group-hover:zoom'; image.src = story.src; image.alt = story.title;
          if (story.srcset) image.srcset = story.srcset;
          image.sizes = '(min-width: 1400px) 280px, 22vw';
          const caption = document.createElement('span'); caption.className = 'mega-menu-split__caption'; caption.textContent = story.title;
          frame.append(image); link.append(frame, caption); card.append(link); return card;
        });
        media.replaceChildren(...cards); menu.style.setProperty('--mega-menu-split-cols', '4'); menu.setAttribute('data-case-studies-active','');
      } catch { if (selected) restore(); }
    };
    trigger.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') show(); });
    trigger.addEventListener('focus', show);
    menu.querySelectorAll('.mega-menu-split__nav a:not([data-case-studies-link])').forEach(link => {
      link.addEventListener('pointerenter', restore); link.addEventListener('focus', restore);
    });
    menu.addEventListener('pointerleave', restore);
    menu.addEventListener('focusout', event => { if (!menu.contains(event.relatedTarget)) restore(); });
  });
  window.beauLakeCaseStudiesInit = initialize;
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true}); else initialize();
})();
